export const ContentTypes = [
  { id: "ALL", value: "ALL" },
  { id: "Images", value: "Image Gallery" },
  { id: "Videos", value: "Video Gallery" },
  { id: "Gallery", value: "Gallery" },
  { id: "Accolades", value: "Accolades" },
  { id: "ServiceCard", value: "Service Card" },
  { id: "Articles", value: "Articles" },
  { id: "VOD", value: "VOD" },
  { id: "Quiz", value: "Quiz" },
  { id: "Poll", value: "Poll" },
];
export const ROW_SIZE = 20;
export const SORT_ORDER = "DESC";
export const SORT_ORDER_ASC = "ASC";

/**
 * Sort choices for the content listing's "Sort By" menu. Used verbatim by the menu, the
 * `?sort=` URL param and `resolveSort`, so they must stay in step across libs/content and
 * libs/authoring-apis.
 *
 * - NEWEST / OLDEST -> `sort` alone (lastModificationDate). Unchanged, so existing
 *   `?sort=` links and the default listing still behave as before.
 * - TITLE_AZ / TITLE_ZA -> `sortOptions: { title }`
 * - PUBLISHED_* / CREATED_* -> `sortOptions: { date, date_type }`
 *
 * Listing only: the content picker uses `authoring_getDynamicContentSearch`, which takes no
 * `sort` at all - see contentGalleryQueries.ts.
 */
export const CONTENT_SORT_VALUES = {
  NEWEST: "newest",
  OLDEST: "oldest",
  TITLE_AZ: "title_az",
  TITLE_ZA: "title_za",
  PUBLISHED_NEWEST: "published_newest",
  PUBLISHED_OLDEST: "published_oldest",
  CREATED_NEWEST: "created_newest",
  CREATED_OLDEST: "created_oldest",
} as const;

/** `sortOptions.date_type` values the gateway accepts. */
export const CONTENT_SORT_DATE_TYPES = {
  PUBLISHED: "published",
  CREATED: "created",
  MODIFIED: "modified",
} as const;
export const ContentGalleryTypes = [
  "ALL",
  "ServiceCard",
  "ImageGallery",
  "VideoGallery",
  "Gallery",
  "Accolades",
  "Article",
  "VOD",
  "Quiz",
  "Poll",
  "Event",
];

export const ContentGalleryTypes1 = [
  "ImageGallery",
  "VideoGallery",
  "Gallery",
  "Article",
  "VOD",
  "Quiz",
  "Poll",
  "Event",
];

export const LanguageList = [
  { id: "en", value: "English (UK)" },
  { id: "fr", value: "French" },
  { id: "de", value: "German" },
];

export const DefaultLocale = "en";
export const CATEGORY_CONTENT = "content";
export const CATEGORY_PAGE = "Page";
export const SORTED_ORDER = "ASC";
export const MENU_STATE_DRAFT = "DRAFT";
export const MENU_TAGGING = "Navigation";
export const USERNAME_EMAIL_EXIST = "Username already exist!";
export const CONTENT_TYPES = ["article", "quiz", "poll", "event"];
export const SITE_PAGE = "SitePage";

export const ImageCropOrder = {
  1440: "hero",
  1280: "landscape",
  1024: "card2",
  768: "square",
  600: "card1",
  320: "portrait",
};

export const SNOWPLOW = {
  NA: "NA",
  SNOWPLOW: "snowplow",
  TRACKID: "selfDescribingEvent",
  IMPRESSIONTYPE: "user register Impression",
  REGISTERFROM: "Rendering",
  COLLECTOR_URL: "collector.hcl-x.com",
  APP_ID: "x",
  APP_NAME: "plateform-x-authoring-app",
};
